import { Form, DatePicker, Select, Button } from 'antd';
import React from 'react';


const {RangePicker} = DatePicker;

const AppointmentFilters = ({updateSignal}) => {
    const {form} = Form.useForm();

    const appointmentStatuses = [
        {value: 2, label: 'BEKLİYOR'},
        {value: 0, label: 'OLUMLU'},
        {value: 1, label: 'OLUMSUZ'}
    ];

    const onFormSubmit = (fields) => {
        const {dateRanges, appointmentStatus} = fields;
        updateSignal(appointmentStatus, dateRanges);
    };

    return(
        <React.Fragment>
            <Form form={form} layout='inline' onFinish={onFormSubmit}>
                <Form.Item name={'dateRanges'}>
                    <RangePicker format='DD/MM/YYYY' style={{maxWidth: '250px'}}/>
                </Form.Item>
                <Form.Item name={'appointmentStatus'}>
                    <Select style={{minWidth: '150px'}} placeholder={'Randevu Durumu'} options={appointmentStatuses} allowClear/>
                </Form.Item>
                <Form.Item>
                    <Button htmlType='submit' type='primary'>Güncelle</Button>
                </Form.Item>
            </Form>
        </React.Fragment>
    )
}
export default AppointmentFilters;